module.exports = __webpack_public_path__ + "assets1775130923925/img/robot.a01b16c5.png";